import React from 'react';
import { Box, Toolbar } from '@mui/material';
import { Routes, Route, useNavigate } from 'react-router-dom';
import Navbar from './component/navbar';
import AddProduct from './component/admin_modal/addProduct';
import FoundProducts from './component/admin_modal/foundProducts';
import NotFoundProducts from './component/admin_modal/notfoundProducts';

const AdminDashboard = () => {
  const navigate = useNavigate();

  const handleAddProduct = () => {
    navigate('/admin/addProduct');
  };

  const handleFoundProducts = () => {
    navigate('/admin/foundProducts');
  };

  const handleNotFoundProducts = () => {
    navigate('/admin/notfoundProducts');
  };

  return (
    <Box sx={{ minHeight: '100vh', position: 'relative' }}>
      <Navbar
        onAddProduct={handleAddProduct}
        onFoundProducts={handleFoundProducts}
        onNotFoundProducts={handleNotFoundProducts}
      />
      <Box component="main" sx={{ p: 3 }}>
        <Toolbar />
        <Routes>
          <Route path="addProduct" element={<AddProduct />} />
          <Route path="foundProducts" element={<FoundProducts />} />
          <Route path="notfoundProducts" element={<NotFoundProducts />} />
          <Route path="*" element={<AddProduct />} />
        </Routes>
      </Box>
    </Box>
  );
};

export default AdminDashboard;